import React, { FormEvent, Fragment, useContext, useEffect, useState } from "react";
import {
  Grid,
  Segment,
  Form,
  Button,
  Popup,
  Input,
} from "semantic-ui-react";
import SiteVodafoneList from "./SiteVodafoneList";
import { observer } from "mobx-react-lite";
import SiteVodafoneStore from "../../../app/stores/sitevodafoneStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { RouteComponentProps } from "react-router-dom";

const SiteVodafoneDashboard: React.FC<RouteComponentProps> = ({
  match,
  location,
  history
}) => {
  const sitevodafoneStore = useContext(SiteVodafoneStore);
  const {
    submitting,
    searchSiteVodafones,
    clearSiteVodafone,
    sitevodafonenamesByDate,
  } = sitevodafoneStore;

  const [search, setSearch] = useState({
    siteId: "",
    siteName: "",
  });

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    if (query.get("siteid"))
    { 
      setSearch({ ...search, ["siteId"]: query.get("siteid")! });
      searchSiteVodafones({siteId: query.get("siteid")!, siteName: "",});
    }
  }, []);

  if (sitevodafoneStore.loadingInitial)
    return <LoadingComponent content="Loading SiteVodafones" />;

  const handleSubmit = () => {
    searchSiteVodafones(search);
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setSearch({ ...search, [name]: value });
  };

  return (
    <Segment>
          <Form onSubmit={handleSubmit}>
            <Grid>
            <Grid.Column width={6}>
            <Form.Field inline >
                <label>Site ID</label>
                <Input
                  onChange={handleInputChange}
                  name='siteId'
                  placeholder='Site ID'
                  value={search.siteId} />
              </Form.Field>
            {/* <Form.Input
          label='Site ID'
          onChange={handleInputChange}
          name='siteId'
          placeholder='Site ID'
          value={search.siteId}
        /> */}
        </Grid.Column>
        <Grid.Column width={7}>
            <Form.Field inline >
                <label>Site Name</label>
                <Input
                  onChange={handleInputChange}
                  name='siteName'
                  placeholder='Site Name'
                  value={search.siteName} />
              </Form.Field>
            {/* <Form.Input
          label='Site Name'
          onChange={handleInputChange}
          name='siteName'
          placeholder='Site Name'
          value={search.siteName}
        /> */}
        </Grid.Column>

        <Grid.Column width={3}>
            <Button
              loading={submitting}
              floated="right"
              positive
              type="submit"
              content="Search"
            />
            </Grid.Column>
            </Grid>
          </Form>
      <Grid>
        <Grid.Column>
          <SiteVodafoneList />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default observer(SiteVodafoneDashboard);
